export default [{
    name: 'hotelGJList',
    path: '/mall/hotelGJ/hotelList',
    component: resolve => require(['./hotelList.vue'], resolve)
}]


// WEBPACK FOOTER //
// ./src/views/mall/hotelGJ/router.js